import { Reducer } from 'redux';

import { loadSession } from '../services/authentication';
import { ActionTypes } from '../types/action-types';
import {
    ActionObject, AUTHENTICATION_STATE, ISession, ISessionHolder
} from '../types/authentication';

const ANONYMOUS_USER = {
  email: 'anonymous@example.com',
  id: '',
}

export const ANONYMOUS_SESSION: ISession = {
  user: ANONYMOUS_USER
}

export default ((state = loadSession(), action: ActionObject): ISessionHolder => {
  switch (action.type) {
    case ActionTypes.USER_LOGIN_SUCCESS:
      return {
        session: action.session,
        state: AUTHENTICATION_STATE.LOGGED_IN,
      };
    case ActionTypes.USER_LOGIN_REQUEST:
      return {
        session: {
          user: ANONYMOUS_USER
        },
        state: AUTHENTICATION_STATE.LOGIN_PROMPTED,
      };
    case ActionTypes.USER_LOGIN_FAILURE:
      return {
        session: {
          user: ANONYMOUS_USER
        },
        state: AUTHENTICATION_STATE.LOGIN_FAILED,
      };
    case ActionTypes.USER_LOGOUT_SUCCESS:
      return {
        session: {
          user: ANONYMOUS_USER
        },
        state: AUTHENTICATION_STATE.LOGGED_OUT,
      };
  }
  return {...state};
}) as Reducer<ISessionHolder>;



// WEBPACK FOOTER //
// ./src/reducers/authentication.ts